import { useBoolean } from "src/hooks/useBoolean";
import { Logo } from "./Navigator/Logo";
import { useAuth } from "src/contexts/auth.context";
import { IconLogout, IconLayoutGrid } from "@tabler/icons-react";
import { Link } from "react-router-dom";
import classNames from "classnames";
import { useTranslation } from "src/translations";
import { useFeatureFlag } from "src/contexts/posthog.context";
import { FLAGS } from "src/posthog/flags";

export function HomeNavigator() {
  const expand = useBoolean();
  const auth = useAuth();
  const { t } = useTranslation();
  const showAdmin = useFeatureFlag(FLAGS.admin);
  return (
    <div className="flex flex-col relative w-[48px] bg-white">
      <div
        onMouseEnter={expand.on}
        onMouseLeave={expand.off}
        className={classNames(
          "bg-white flex flex-col absolute border-r h-full border-black/20 shrink-0 shadow-elevation-2 z-50",
          expand.isOff && "w-[48px]",
          expand.isOn && "w-[236px] shadow"
        )}
      >
        <div className="flex flex-col justify-between h-full">
          <div className="py-4 ml-2">
            <Logo expand={expand} />
          </div>
          <div className="flex flex-col">
            {showAdmin && (
              <Link
                to="/admin"
                title={t("nav.admin")}
                className="flex items-center gap-2 px-3 py-3 text-neutral-6 hover:text-primary-7 hover:bg-primary-2 border-t border-black/10"
              >
                <IconLayoutGrid className="w-5 h-5 shrink-0" />
                {expand.isOn && <span className="text-body-1 truncate">{t("nav.admin")}</span>}
              </Link>
            )}
            <button
              onClick={auth.logout}
              title={t("nav.logout")}
              className="flex items-center gap-2 px-3 py-3 text-neutral-6 hover:text-primary-7 hover:bg-primary-2 border-t border-black/10"
            >
              <IconLogout className="w-5 h-5 shrink-0" />
              {expand.isOn && <span className="text-body-1 truncate">{t("nav.logout")}</span>}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
